<template>
  <div>
    <!--页面头部-->
    <slot>
      <div v-if="ifOtherHeader" class="shy-header">
        <div class="header-inner">
          <div class="backgw" v-if="ifShowBack" @click="goGw">
            <span>&lt; 返回官网</span>
          </div>
          <div class="logo">
            <img src="@/assets/images/common/logo.png" />
          </div>
          <div class="login-header">
            <img src="@/assets/images/common/login-icon.png" alt="" />
            <div v-if="!login">
              <a
                @click="loginChange(true)"
                id="login"
                href="javascript:void(0);"
                >登录</a
              >
            </div>
            <div class="username" v-else>
              <span @click="goOrderList">{{ userInfoCon.loginName }}</span>
              <a class="ml10" @click="logout()" href="javascript:void(0);"
                >退出</a
              >
            </div>
          </div>
        </div>
      </div>
      <div v-else class="header">
        <div class="header-top">
          <div class="header-login">
             <span v-if="login" class="hello-text">
              <em>你好，欢迎来到LOTS商城！</em>
             </span>
            <!-- <span v-if="!login" class="login-text"> -->
              <!-- <em @click="loginChange(true, false)">你好，请登录</em> -->
           <!-- </span>
            <span class="login-text" v-else>
              <em @click="goOrderList">{{ userInfo.loginName }}</em>
              <a class="ml10" @click="logout()" href="javascript:void(0);"
                >退出</a
              >
            </span>
            <span class="reg-text">
              <em @click="loginChange(true, true)">免费注册</em>
            </span> -->
            <div class="header-link-wrap">
              <span class="pointer" v-if="!login" @click="loginChange(true, false)">散客登录</span>
              <span v-if="login" style="color: #F05B47">{{userInfoCon.loginName}}</span>
              <span class="pointer" v-if="login" @click="logout()">退出</span>
              <span>|</span>
              <span v-if="showTeamLogin" class="pointer" @click="toTeamLogin">团队登录</span>
              <span v-if="showTeamLogin">|</span>
              <div :class="['phone-logo', showQrcode ? 'active' : '']" @mouseover="mouseOverPhone" @mouseleave="mouseLeavePhone">
                <img :src="showQrcode ? require('@/assets/images/phone-r.png') : require('@/assets/images/phone-b.png')" />
                <div v-show="showQrcode" class="qrcode-wrap clearfix">
                  <div class="line"></div>
                  <div class="qr-code">
                    <qrcode :value="qrcodeUrl" :options="{ size: 60 }"></qrcode>
                  </div>
                  <div class="scan-wrap">
                    <p>微信扫码</p>
                    <p>了解更多</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header-bottom">
          <div
            class="header-main clearfix"
            :class="{ asdad: ifShopInfo }"
            :style="{
              background: ifShopInfo
                ? ' url(' +
                  shopInfoData.backUrl +
                  ') 0% 0% / 100% 100% no-repeat'
                : ''
            }"
          >
            <div class="shop-info" v-if="ifShopInfo">
              <div class="shop-img">
                <img class="bgc-img" :src="shopInfoData.logoUrl" alt />
              </div>
            </div>

            <div class="logo"  v-else v-on:mouseenter="visible" @mouseleave="invisible">
              <img :src="merchantData.logoAddr" />
              
            </div>
           <div class="logo-tips" v-show="isShow">{{merchantData.name}}</div> 
            <div class="merchant-name" v-if="merchantData.merchantSignShow!==1">{{merchantData.name}}</div>
            <div class="header-main-con">
              <div class="weather">
                <weather v-if="ifWeather" :pageData="weatherData"></weather>
              </div>
              <div class="header-search" :class="ifWeather ? 'ml60' : 'ml30'">
                <input
                  type="text"
                  class="search-input"
                  placeholder="搜索提示文字"
                />
                <span class="search-btn">
                  <!-- <i class="xx-icon icon-sousuo-m icon-search"></i> -->
                  搜索
                </span>
              </div>

              <div class="shopinfo-con" v-if="ifShopInfo">
                {{ shopInfoData.introduction }}
              </div>
              <div class="shopinfo-con" v-else>
                {{ merchantData.briefIntroduction }}
              </div>
            </div>

            <div class="service-wap">
              <div>
                <span v-if="merchantData.customerServices&&merchantData.customerServices.length>1" class="img-top1"><img src="@/assets/images/tel.png" alt=""></span>
                <span v-else class="img-top2"><img src="@/assets/images/tel.png" alt=""></span>
                <ul>
                  <li v-for="(item,index) in merchantData.customerServices" :key="index">{{item}}</li>
                </ul>
                
              </div>
              
            </div>
          </div>
        </div>
        <div v-if="ifNotice">
          <notice :pageData="noticeData"></notice>
        </div>

        <div
          v-if="navData && navData.list"
          class="nav"
          :style="{
            backgroundColor: navData.backgroundColor,
            'border-top': '3px solid ' + navData.backgroundLineColor
          }"
        >
          <ul class="nav-ul clearfix">
            <li
              v-for="(item, index) in navData.list"
              :key="index"
              :class="{ on: item.linkUrl == pageType }"
              @click="gotoTarget(item)"
              :style="{
                backgroundColor:
                  item.linkUrl == pageType
                    ? navData.selectBackgroundColor
                    : navData.backgroundColor
              }"
            >
              <span
                :style="{
                  color:
                    item.linkUrl == pageType
                      ? navData.selectTextColor
                      : navData.textColor
                }"
                >{{ item.title }}</span
              >
              <i class="xsj-icon"></i>
            </li>
          </ul>
        </div>
      </div>
    </slot>
    <!--登录子组件-->
    <!-- <div class="login-wrap" v-if="!ifOtherHeader" v-show="loginShow">
      <div class="login-close" @click="loginChange(false, false)"></div>
      <hello ref="loginModal"></hello>
    </div>
    <div class="login-wrap" v-else v-show="loginShow">
      <div class="login-close" @click="loginChange(false)"></div>
      <hello></hello>
    </div> -->

    <!-- 登录弹框 -->
    <!-- <login v-model="showLogin" @handleReg="handleReg" @handleModifyPas="handleModifyPas" /> -->
    <login v-model="loginShow" @handleReg="handleReg" @handleModifyPas="handleModifyPas" />

    <!-- 注册弹框 -->
    <reg v-model="showReg" @handleLogin="handleLogin" />

    <!-- 忘记密码 -->
    <modify-pas v-model="showModifyPas" @handleLogin="handleLogin" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { apiGet, apiPost } from "@/fetch/api";
import api from "@/api/api";
import qrcode from "@xkeshi/vue-qrcode";
import hello from "@/components/login";
import notice from "@/components/custompage/customComponent/notice";
import weather from "@/components/custompage/customComponent/weather";
import login from "@/components/modal/login";
import reg from "@/components/modal/reg";
import modifyPas from "@/components/modal/modifyPas";
export default {
  name: "Header",
  props: {
    ifOtherHeader: {
      type: Boolean
    },
    ifShowBack: {
      type: Boolean
    },
    ifNotice: {
      type: Boolean
    },
    merchantData: {
      type: Object
    },
    navData: {
      type: Object
    },
    qrcodeUrl: {
      type: String
    },
    privateId: {
      type: Number
    }
  },
  data() {
    return {
      noticeData: [],
      ifShopInfo: false,
      shopInfoData: {},
      customBackgroundColor: "",
      homeTitle: "",
      website: "",
      weatherData: {},
      ifWeather: false,
      showLogin: false,
      showReg: false,
      showModifyPas: false,
      showQrcode: false,
      showTeamLogin: false,
      isShow:false,
      // login: false,
    };
  },
  components: {
    notice,
    hello,
    weather,
    qrcode,
    login,
    reg,
    modifyPas,
  },
  watch: {
    "$store.state.login"(val) {
      this.loginBtn = false;
      this.formItem = {
        loginName: "",
        loginPass: "",
        merchantInfoId: this.$route.query.m_id
      };
    }
  },
  computed: {
    // ...mapState(["login", "userInfo", "pageType", "loginShow"])
    ...mapState(["pageType", "loginShow"]),
    ...mapGetters(['tokenInfo', 'userInfoCon']),
    login(){
      if(!this.tokenInfo || (this.tokenInfo && !Object.keys(this.tokenInfo).length)){
        return false;
      }else{
        return true;
      }
    },
  },
  created() {
    this.teamLogin()
  },
  mounted(){
  },
  methods: {
    ...mapMutations(['removeTokenInfo', 'removeUserInfoCon']),
    ...mapActions(['setTokenInfo']),
    // 团队预订登录
    toTeamLogin(){
      window.location.href = 'https://www.lotsmall.cn/admin/storeMerchant/login#';
    },
    // 是否开启团队登录
    teamLogin(){
      apiGet("/merchant/api/merchantRenovationToc/getGroupLoginSwitch", {
        merchantInfoId: this.$route.query.m_id
      }).then(res => {
        if (Number(res.status) === 200) {
          this.showTeamLogin = res.data;
        } else {
          this.$Message.warning(res.message);
        }
      });
    },
    // 鼠标移入
    mouseOverPhone(){
      this.showQrcode = true;
    },
    // 鼠标移出
    mouseLeavePhone(){
      this.showQrcode = false;
    },
    visible:function(){
      this.isShow = true;
    },
    invisible:function(){
      this.isShow = false;
    },
    // 登录
    handleLogin(){
      this.showModifyPas = false;
      this.showReg = false;
      // this.showLogin = true;
      this.$store.state.loginShow = true;
    },
    // 注册
    handleReg(){
      this.showModifyPas = false;
      // this.showLogin = false;
      this.$store.state.loginShow = false;
      this.showReg = true;
    },
    handleModifyPas(){
      // this.showLogin = false;
      this.$store.state.loginShow = false;
      this.showReg = false;
      this.showModifyPas = true;
    },
    logout() {
      let _this = this;
      apiGet("/leaguer/api/userLeaguer/manage/leaguerLogout", {
        merchantInfoId: this.$route.query.m_id || localStorage.getItem("m_id")
      }).then(res => {
        if (res.status == 200) {
          // localStorage.clear();
          // localStorage.removeItem("xjsc_login_access_token_2019_3_7");
          this.removeTokenInfo();
          localStorage.removeItem("xjsc_login_userId_2019_3_8");
          // localStorage.removeItem('user_info_20201231');
          this.removeUserInfoCon()
          // _this.reload();
          location.reload();
          // _this.refresh();
          _this.$Message.success("退出成功!");
          _this.$store.dispatch("updateLogin", false);
        } else {
          _this.$Message.warning(res.message);
        }
      });
      // _this.refresh();
    },
    loginChange(bool, isLoginRegister) {
      // this.$store.state.loginShow = bool;
      // if (isLoginRegister) {
      //   this.$nextTick(() => {
      //     this.$refs.loginModal.loginBtn = isLoginRegister
      //       ? isLoginRegister
      //       : false;
      //   });
      // }
      this.$store.state.loginShow = bool;
      // this.showLogin = true;
      // if (isLoginRegister) {
      //   this.$nextTick(() => {
      //     this.$refs.loginModal.loginBtn = isLoginRegister
      //       ? isLoginRegister
      //       : false;
      //   });
      // }
    },
    goOrderList() {
      this.$parent.goOrderList();
    },
    goGw() {
      window.location.href = "http://www.qingmings.com/shop.php";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.header {
  // height: 200px;
  position: relative;
  z-index: 0;
  // border-bottom: 1px solid #e6e6e6;
  background: white;
  font-family: SimSun;
}
.header {
  width: 100%;
  .logo-tips{
    position: absolute;
    top: 30px;
    left: 51px;
    z-index: 999;
    color: #666;
    border: 1px solid #eee;
    padding: 5px 5px;
    background: #fff;
    border-radius: 5px;
  }
  .header-top {
    height: 25px;
    background-color: #f7f7f7;
    .header-login {
      height: 25px;
      line-height: 25px;
      width: 1200px;
      margin: 0 auto;
      // padding-left: 100px;
     
      .header-link-wrap{
        float: right;
        span{
          display: inline-block;
          vertical-align: middle;
          color: #999;
          font-size: 12px;
          font-family: SimSun;
          padding: 0 1px 0 3px;
          &.pointer{
            cursor: pointer;
          }
        }
        .phone-logo{
          display: inline-block;
          width: 20px;
          height: 30px;
          position: relative;
          border: 1px solid #f7f7f7;
          border-bottom: none;
          &.active{
            background: #fff;
            border-color: #DDD;
            box-shadow: 0px 3px 13px 0px rgba(77, 77, 77, 0.1);
          }
          img{
            width: 9px;
            height: 14px;
            display: inline-block;
            vertical-align: middle;
            margin-left: 5px;
          }
          .qrcode-wrap{
            width: 129px;
            background: #fff;
            border: 1px solid #DDD;
            box-shadow: 0px 3px 13px 0px rgba(77, 77, 77, 0.1);
            border-top: none;
            position: absolute;
            right: -1px;
            top: 23px;
            z-index: 999;
            .line{
              width: 109px;
              height: 1px;
              background: #DDD;
            }
            .qr-code{
              float: left;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 3px;
            }
            .scan-wrap{
              font-size: 12px;
              font-family: SimSun;
              font-weight: 400;
              color: #666;
              float: left;
              margin: 10px 0 0 4px;
              // padding: 0 6px 0 4px;
            }
          }
        }
      }
      .hello-text {
        color: #000;
        font-size: 12px;
        em {
          font-style: normal;
        }
      }
      .login-text {
        color: #f05b47;
        font-size: 12px;
        em {
          cursor: pointer;
          font-style: normal;
        }
      }
      .reg-text {
        font-size: 12px;
        color: #999;
        margin-left: 16px;
        em {
          cursor: pointer;
          font-style: normal;
        }
      }
    }
  }
  .header-bottom {
    height: 95px;
    background-color: #fff;
    position: relative;
    .header-main {
      width: 1200px;
      height: 95px;
      margin: 0 auto;
      position: relative;
      .shop-info {
        float: left;
        margin-left: 40px;
        height: 58px;
        margin-top: 18px;
        position: relative;
        .shop-img {
          width: 100%;
          height: 100%;
          .bgc-img {
            max-width: 182px;
            height: 58px;
          }
        }
      }
      .logo {
       
        height: 50px;
        float: left;
        margin-top: 18px;
        img {
          display: block;
         
          height: 50px;
        }
      }
      .merchant-name{
        float: left;
        font-size: 20px;
        font-weight: 500;
        color: #333;
        margin: 30px 0 10px 6px;
        font-family: PingFang SC;
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
      }
      .header-main-con {
        width: 350px;
        float: left;
        position: relative;
        // flex: 1;
        margin: 0 30px 0 120px;
        .ml60 {
          margin-left: 60px;
        }
        .ml30 {
          margin-left: 0;
        }
        .weather {
          float: left;
          margin-top: 18px;
          height: 40px;
          overflow: hidden;
        }
        .header-search {
          width: 346px;
          float: left;
          height: 32px;
          position: relative;
          margin-top: 20px;
          overflow: hidden;
          input::placeholder{
            font-size: 12px;
            color:#999;
          } 
          .search-input {
            width: 346px;
            border: 1px solid #f05b47;
            height: 32px;
            line-height: 32px;
            border-radius: 4px;
            padding: 0 60px 0 6px;
            font-size: 14px;
            color: #999;
          }       
          .search-btn {
            display: block;
            position: absolute;
            width: 55px;
            text-align: center;
            right: 0;
            top: 0;
            height: 32px;
            line-height: 32px;
            background-color: #f05b47;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            cursor: pointer;
            color: #fff;
            font-size: 12px;
            font-family: SimSun;
            i {
              font-style: normal;
              color: #fff;
              font-size: 14px;
            }
          }
        }
        .shopinfo-con {
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          overflow: hidden;
          //  overflow:hidden;
          // text-overflow:ellipsis;
          // white-space:nowrap;
          font-size: 12px;
          color: #999;
          position: absolute;
          top: 58px;
          // left: 212px;
          left: 0;
          width: 100%;
          max-height: 20px;
          line-height: 20px;
          // width: calc(100%-30px);
          // min-width: 756px;
          // max-width: 900px;
          // height: 20px;
        }
      }
      .service-wap{
        margin-left: 102px;
        float: right;
        margin-top: 20px;
        font-weight: 400;
        width: 160px;
        ul{
          float: left;
        }
         li{
            display: block;
            font-weight: bold;
            color: #F05B47;
            font-size: 14px;
            width: 104px;
            overflow: hidden;
            height: 20px;
            white-space: nowrap;
          }
        img{
          display:block;
          margin-left: 8px;
          margin-right: 10px;
          float: left;
        }
        .img-top1 img{
          margin-top:15px;
        }
      }
    }
  }

  .nav {
    width: 100%;
    // background-color: #f88475;
    height: 45px;
    // border-top: 3px solid #f05b47;
    .nav-ul {
      width: 1200px;
      margin: 0 auto;
      height: 45px;
      li {
        float: left;
        height: 42px;
        line-height: 42px;
        font-size: 16px;
        // color: #fff;
        width: 8.33%;
        text-align: center;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        .xsj-icon {
          display: none;
          // background: url("./assets/images/common/nav-li-on.png") center bottom
          //   no-repeat;
          background-size: 100%;
          width: 10px;
          height: 5px;
          position: absolute;
          bottom: 0;
          left: 50%;
          margin-left: -5px;
        }
      }

      li.on {
        background-color: #f05b47;
        .xsj-icon {
          display: block;
        }
      }
      li:hover {
        background-color: #f05b47;
      }
    }
  }
}
.header-qrcode {
  float: right;
  // margin-left: 72px;
  margin-top: 17px;
  height: 60px;
  // margin-right: 40px;
  margin-right: 100px;
  width: 152px;
  .qr-code {
    display: block;
    width: 60px;
    height: 60px;
    float: left;
  }
  .scan {
    float: left;
    margin-top: 16px;
    margin-left: 8px;
    .scan-care {
      .mobile-icon {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        vertical-align: bottom;
        width: 11px;
        height: 17px;
      }
      .scan-text {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        vertical-align: bottom;
        color: #413838;
        font-size: 12px;
      }
    }
    .know-more {
      font-size: 12px;
      color: #413838;
    }
  }
}
.shy-header {
  height: 136px;
  position: relative;
  z-index: 0;
  border-bottom: 1px solid #e6e6e6;
  min-width: 1200px;
  overflow: hidden;
  .header-inner {
    width: 1200px;
    margin: 0 auto;
    zoom: 1;
    height: 136px;
    overflow: hidden;
    .header-inner:after {
      display: block;
      clear: both;
      visibility: hidden;
      height: 0;
      overflow: hidden;
      content: ".";
    }
    .logo {
      width: 255px;
      height: 94px;
      float: left;
      margin-top: 21px;
      margin-left: 370px;
      a {
        width: 100%;
        height: 100%;
        display: block;
        margin-left: 10px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .backgw {
      float: left;
      height: 20px;
      line-height: 20px;
      margin-top: 58px;
      font-size: 14px;
      color: #afafaf;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue